import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '@/lib/api';

const InstanceCtx = createContext({
  instances: [],
  current: null,
  setCurrent: () => {},
  refresh: async () => {},
  loading: false,
});

export function InstanceProvider({ children }) {
  const [instances, setInstances] = useState([]);
  const [current, setCurrent] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    setLoading(true);
    try {
      const list = await api.listInstances();
      setInstances(list);
      if (!current && list.length > 0) {
        const open = list.find((i) => i.connectionStatus === 'open') || list[0];
        setCurrent(open.instanceName);
      } else if (current && !list.find((i) => i.instanceName === current)) {
        setCurrent(list[0]?.instanceName || null);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 12000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InstanceCtx.Provider value={{ instances, current, setCurrent, refresh, loading }}>
      {children}
    </InstanceCtx.Provider>
  );
}

export function useInstances() {
  return useContext(InstanceCtx);
}
